import React, {Component} from 'react';

import {ClientAgentContent} from "./agent/ClientAgentContent";
import {withRouterParams} from "../../utils/withRouterParams";

export class ClientAgent extends Component {
    render() {
        return (
            <ClientAgentContent
                clientId={this.props.match.params.id}
                sessionId={this.props.match.params.sessionId}
            />
        )
    }
}

export default withRouterParams(ClientAgent);
